import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const deleteForceReducer = (state: ForceState, { id }: ReturnType<typeof FORCE_ACTIONS.DELETE_FORCE>) => {
    return {
        ...state,
        forces: state.forces.filter((f) => f.id !== id)
    };
};
